import React from 'react'
import { CommonContext } from '@ssr/context'

const APP_ID_DEV = '07519d64d7f240628e8e9a78cefddb7f'
const APP_ID_PROD = '6eef93a708a34557a93696cad042ccc4'

export default function ThinkingDataSDK() {
  const { metaData } = React.useContext(CommonContext)
  const appId = metaData.isDev ? APP_ID_DEV : APP_ID_PROD
  return (
    <script
      key='thinking-data-sdk'
      dangerouslySetInnerHTML={{
        __html: `
          !function (e) { if (!window.ThinkingDataAnalyticalTool) { var n = e.sdkUrl, t = e.name, r = window, a = document, i = "script", l = null, s = null; r.ThinkingDataAnalyticalTool = t; var o = ["track", "quick", "login", "identify", "logout", "trackLink", "userSet", "userSetOnce", "userAdd", "userDel", "setPageProperty", "setSuperProperties", "setDynamicSuperProperties", "clearSuperProperties", "timeEvent", "unsetSuperProperties", "initInstance", "trackFirstEvent", "trackUpdate", "trackOverwrite"]; r[t] = function (e) { return function () { if (this.name) (r[t]._q = r[t]._q || []).push([e, arguments, this.name]); else if ("initInstance" === e) { var n = arguments[0]; r[t][n] = { name: n }; for (var a = 0; a < o.length; a++)r[t][n][o[a]] = r[t].call(r[t][n], o[a]); (r[t]._q1 = r[t]._q1 || []).push([e, arguments]) } else (r[t]._q = r[t]._q || []).push([e, arguments]) } }; for (var u = 0; u < o.length; u++)r[t][o[u]] = r[t].call(null, o[u]); r[t].param = e, r[t].__SV = 1.1, l = a.createElement(i), s = a.getElementsByTagName(i)[0], l.async = 1, l.src = n, s.parentNode.insertBefore(l, s) } }(
          {
              appId:'${appId}', //系统分配的APPID
              name: 'ta', //全局的调用变量名，可以任意设置，后续的调用使用该名称即可
              sdkUrl:'https://res.insta360.com/static/assets/storage/20200714/910b039c4115f9f54d62321023b1d0f3/thinkingdata.min.js', //统计脚本URL
              serverUrl:'https://appdata.insta360.cn/sync_js', //数据上传的URL
              loaded: function(ta) {
                // var currentId = ta.getDistinctId();
                // ta.identify(currentId);
                // ta.quick('autoTrack');
              },
              showLog: ${metaData.isDev},
              useAppTrack: true // 打通 APP 与 H5
          });
        `,
      }}
    />
  )
}
